import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import theme from 'shared/themes/default';
import QuestionAccordion from '../components/QuestionAccordion';

const EditTestTabStyle = styled.div`
  max-height: 30rem;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: ${theme.spacing.m1};
  background: transparent;
  ::-webkit-scrollbar {
    width: 10px;
    height: 30px;
  }
  ::-webkit-scrollbar-thumb:vertical {
    height: 30px;
    background-color: ${theme.palette.disabledLight};
    border-radius: 10px;
  }
`;

const EditTest = ({
  alwaysExpanded,
  disabled,
  isEditing,
  selectedLanguage,
  questions,
  setQuestions,
  theme: themeLayout,
}) => {
  const [openQuestion, setOpenQuestion] = useState(-1);

  const handleChangeQuestion = (index, question) => {
    const newQuestions = [...questions];
    newQuestions[index] = question;
    setQuestions(newQuestions);
  };

  return (
    <EditTestTabStyle>
      {questions.map((question, index) => (
        <QuestionAccordion
          disabled={disabled}
          index={index}
          isEditing={!alwaysExpanded && isEditing}
          key={index}
          selectedLanguage={selectedLanguage}
          onChangeQuestion={(question) => handleChangeQuestion(index, question)}
          openQuestion={openQuestion}
          question={question}
          setOpenQuestion={setOpenQuestion}
          theme={themeLayout}
        />
      ))}
    </EditTestTabStyle>
  );
};

EditTest.propTypes = {
  alwaysExpanded: PropTypes.bool,
  disabled: PropTypes.bool,
  isEditing: PropTypes.bool,
  selectedLanguage: PropTypes.string.isRequired,
  questions: PropTypes.array.isRequired,
  setQuestions: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

EditTest.defaultProps = {
  theme: 'light',
};

export default EditTest;
